export default __webpack_public_path__ + "static/media/piece1.2fb3f1b0.webp";